/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `claude` - Claude API
 * `suno` - Suno API
 * `openai` - OpenAI API
 * `youtube` - YouTube API
 * `kling` - Kling API
 */
export type ServiceTypeEnum =
  (typeof ServiceTypeEnum)[keyof typeof ServiceTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceTypeEnum = {
  claude: "claude",
  suno: "suno",
  openai: "openai",
  youtube: "youtube",
  kling: "kling",
} as const;
